import React, { useState, useEffect, useRef } from 'react';

import { Redirect, Route, Switch/*, useLocation*/ } from 'react-router-dom';
//import {useLocation } from 'react-router-dom';

import './App.css';

//import Login from './components/Login/Login';

import useToken from './UseToken';

import Pagina from './components/Pagina/Pagina';
//import AppForm from './components/Pagina/Forms/AppForm';



/*import politicaPrivacidade from "./components/Pagina/Conteudo/politicaPrivacidade"; */
//import termosCondicoes from "./components/Pagina/Conteudo/termosCondicoes";

import Cookies from "./components/Pagina/Cookies/Cookies";

import GoTopButton from './components/Pagina/GoTopButton/GoTopButton';

import Content from './components/Pagina/Content/Content';
// import RoutesCards from './components/Pagina/EstrelaMaior/RoutesCards';
// import Routes from './components/Pagina/EstrelaMaior/Routes';

import Store from './components/Pagina/Store/Content';

//import Forfaits from './components/Pagina/Forfait/Forfait';
//import Equipamentos from './components/Pagina/Equipamento/Equipamento';
// import Vouchers from './components/Pagina/Voucher/Voucher';
import Packs from './components/Pagina/Pack/Pack';
import Atividades from './components/Pagina/Atividade/Atividade';
import Cart from './components/Pagina/Cart/Cart';
import PaymentNotificationPage from './components/Pagina/Store/PaymentNotificationPage';
import PaymentNotificationPageApp from './components/Pagina/Store/PaymentNotificationPageApp';
//import Aula from './components/Pagina/Aula/Aula';
//import Aula_Store from './components/Pagina/Aula_Store/Aula_Store';

//import Reservas from './components/Pagina/GoldenRock/Reserva';
//import Service from './components/Pagina/GoldenRock/Service';
//import GoldenRock_Cart from './components/Pagina/GoldenRock/Cart';

//import Entrance from './components/Pagina/GoldenRock/Entrance';

//import MapaPistas from './components/Pagina/MapaPistas/mapaPistas';

//import LiveCam from './components/Pagina/Navbar_Extra/Livecam';
//import Accesses from './components/Pagina/Navbar_Extra/Accesses';

//import Contact from "./components/Pagina/Forms/ContactForm";


//import RegistClient from "./components/Pagina/Forms/RegisterClient";
//import RecoveryClient from "./components/Pagina/Forms/RecoveryClient";

//import PerfilClient from "./components/Pagina/Cliente/Perfil";
//import OrdersClient from "./components/Pagina/Cliente/Encomendas";
//import HistoricClient from "./components/Pagina/Cliente/Historico";

import AboutCustom from './components/Pagina/WEBContent/AboutCustom';

import RegistFarmer from "./components/Pagina/Forms/RegisterFarmer";
import RecoveryFarmer from "./components/Pagina/Forms/RecoveryFarmer";

import Loader from './loader'

//import Navbar from './components/Pagina/Navbar/Navbar';

//import CookieConsent from "react-cookie-consent";


import * as Hosts from './Hosts';

import "../src/components/Pagina/Pagina.css";

import {
  repo_favicon_link,
  reqGET,
  set_language,
  content_language,
} from './Utils';
//import GenericStore from './components/Pagina/GenericStore/GenericStore';
//import ProdByCategory from './components/Pagina/GenericStore/ProdByCategory';
//import ProdByCategoryDesk from './components/Pagina/GenericStore/ProdByCategoryDesk';
//import ProdByIdDesk from './components/Pagina/GoldenRock/ServiceDesk';
//import CartDesk from './components/Pagina/GoldenRock/CartDesk';
//import useContextProvider from './components/Pagina/GenericStore/Providers/ContextProvider';
//import { useHistory } from 'react-router-dom/cjs/react-router-dom';

//if (process.env.REACT_APP_MODE === 'production') console.log = function () { };

function App() {

  //const { on_init, set_var_timer_countdown, get_lista_carrinho, get_is_logged } = useContextProvider()
  //const history = useHistory();

  //const { pathname } = useLocation();

  const { setToken } = useToken();

  //const [, set_is_loading] = useState(true)



  const handleFavIcon = () => {

    function getFaviconEl() {
      return document.getElementById("favicon");
    }
    const favicon = getFaviconEl(); // Accessing favicon element
    //console.log('FavICON', repo_favicon_link("favicon.ico"))
    //console.log('FavICON get', document.getElementById("favicon"))
    favicon.href = repo_favicon_link("favicon.ico");
    //favicon.href = "favicon.ico";
  };

  // 
  //document.title = `${document.title}-Scientia`
  handleFavIcon()

  //const page_location = useLocation().pathname.split('/').pop();

  //const [lang, set_lang] = useState(localStorage.getItem('lang'));

  //const menus = [];
  //const { sideBarData, setSideBarData, getSidebar } = useSidebar();


  //const [menus, setMenus] = useState([])

  //const [isloading, setLoading] = useState(true);

  //LOADER TIMEOUT
  const [isLoading, setIsLoading] = useState(true);

  const [/*refresh*/, setRefresh] = useState(0);

  const [, set_dados] = useState(null)
  const dados_config = useRef({})
  //const [template, set_template] = useState({})
  //const [theme, set_theme] = useState({})

  const navbar_data_interface = {
      id: '',
      info: {},
      content: {
          childs: []
      }
  }

  const navbar = useRef(navbar_data_interface);

  const [lang, ] = useState(localStorage.getItem('lang'))


  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null) {
      set_language('pt')
    }

    //setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })
    setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })

    const timer = setTimeout(() => {
      setIsLoading(false);
      //setCount('Timeout called!');
    }, 500);

    return () => clearTimeout(timer);

    /*    setTimeout(() => {
        setIsLoading(false);
      }, 500);  */
  }, [setToken])


  /*useEffect(() => {
    setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })
    //console.log('token_site', Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN)

    /* setTimeout(() => {
    setLoading(false)
    /* })

  }, [])*/




  /*useEffect(() => {

    const aux_func = async () => {
      // await  useContextProvider().on_init(set_is_loading)
      await on_init(set_is_loading, history.action, get_lista_carrinho)

      if (get_is_logged() === true) {
        await set_var_timer_countdown()

      }

      console.log('############')

    }

   // (async () => {


     // await aux_func()
      // window.addEventListener("focus", async() => await on_init(set_is_loading));
      //console.error('history.action', history.action)
   // })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])*/

  useEffect(() => {

    const getConfig = async () => {

      await reqGET(`${Hosts.SIMCore_API}/web/settings/type/${Hosts.companycode}/settings`)
        .then(async res => {
  
          if(res.data.length > 0) {
            set_dados(dados_config.current = res.data[0].info?.settings)
            //set_template(res.data[0].info?.settings?.template !== undefined && res.data[0].info?.settings?.template.id !== undefined ? res.data[0].info?.settings?.template : {info: {tag: ''}})
            //set_theme(res.data[0].info?.settings?.theme !== undefined && res.data[0].info?.settings?.theme.id !== undefined ? res.data[0].info?.settings?.theme : {info: {tag: ''}})
            //document.getElementById("head_style").innerHTML = ":root { --primary: " + res.data[0].info?.settings?.theme?.info.color.primary + " !important; --primary-rgb: " + res.data[0].info?.settings?.theme?.info.color.primary_rgb + " !important; --secondary: " + res.data[0].info?.settings?.theme?.info.color.secondary + " !important; }";
          } /*else {
            //set_template({info: {tag: ''}})
            //set_theme({info: {tag: ''}})
          }*/
  
        })
        .catch(erro => console.log('Erro', erro))

      await reqGET(`${Hosts.SIMCore_API}/web/structure/${Hosts.companycode}/1`)
        .then(async res => {
            for await (let v of res.data) {
            // res.data.forEach((v) => {
                if (v.info.principal === true) {

                    if (lang !== 'pt') {
                        for await (let cl of content_language) {
                        // content_language.forEach((cl) => {
                            let x = 0

                            if (cl.code === lang) {

                                v.content.childs.forEach((el) => {
                                    if (el.id_content !== '') {
                                        if (el.children !== undefined) {
                                            x = x - el.children.length
                                            //for await (let el_c of el.children) {
                                            el.children.forEach(async (el_c) => {
                                                await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el_c.id_content}`)
                                                    .then(res_3 => {
                                                        if (res_3.data.length > 0) {
                                                            if (res_3.data[0].info.language.length > 0) {
                                                                if (res_3.data[0].info.language[cl.id] !== undefined && res_3.data[0].info.language[cl.id] !== null) {
                                                                    if (res_3.data[0].info.language[cl.id]['name'] !== '') {
                                                                        el_c.title = res_3.data[0].info.language[cl.id]['name'];

                                                                        x++
                                                                        if (v.content.childs.length === x) {
                                                                            setRefresh(refresh => refresh + 1)
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                x++
                                                                if (v.content.childs.length === x) {
                                                                    setRefresh(refresh => refresh + 1)
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            x++
                                                            if (v.content.childs.length === x) {
                                                                setRefresh(refresh => refresh + 1)
                                                            }
                                                        }
                                                    })
                                            })
                                        }

                                        reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el.id_content}`)
                                            .then(res_2 => {
                                                if (res_2.data.length > 0) {
                                                    if (res_2.data[0].info.language.length > 0) {
                                                        if (res_2.data[0].info.language[cl.id] !== undefined && res_2.data[0].info.language[cl.id] !== null) {
                                                            if (res_2.data[0].info.language[cl.id]['name'] !== '') {
                                                                el.title = res_2.data[0].info.language[cl.id]['name'];

                                                                x++
                                                                if (v.content.childs.length === x) {
                                                                    setRefresh(refresh => refresh + 1)
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        x++
                                                        if (v.content.childs.length === x) {
                                                            setRefresh(refresh => refresh + 1)
                                                        }
                                                    }
                                                }
                                                else {
                                                    x++
                                                    if (v.content.childs.length === x) {
                                                        setRefresh(refresh => refresh + 1)
                                                    }
                                                }
                                            })


                                    }
                                    else {
                                        if (el['language'] !== undefined && el['language'] !== null) {
                                            if (el.language[cl.id] !== undefined && el.language[cl.id]['title'] !== undefined && el.language[cl.id]['title'] !== '') {
                                                el.title = el.language[cl.id]['title']

                                                x++
                                                if (v.content.childs.length === x) {
                                                    setRefresh(refresh => refresh + 1)
                                                }
                                            }
                                        }
                                    }

                                })

                            }
                        }

                    }

                    set_dados(navbar.current = v);
                }
            }
            //console.log('rota da estrutura navbar content.js');

        })
        .catch(erro => console.log('ERROR', erro))
    }
    
    (async () => {
      await getConfig()
    })()

  }, [lang])

  return isLoading ?
      <Loader />
    :
    <>
      <Cookies />
      <GoTopButton />

      <>

        {/* <Navbar /> */}
        {/*  <Pagina /> */}
        <Switch >

          {/* React Router v4 (also works with v5) */}
          <Route path='/' exact render={(props) => <Pagina  {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={Pagina}*/ />
          {/* React Router v5 */}
          {/*<Route path='/'><Pagina dados_config={dados_config.current} dados_navbar={navbar.current} /></Route>*/}
          {/* React Router v6 */}
          {/*<Route path='/' exact element={<Pagina dados_config={dados_config.current} dados_navbar={navbar.current} />} />*/}

          {/*<Route path="/app_form" exact component={AppForm} />*/}

          {/*<Route path={"/terms_conditions"} exact component={termosCondicoes} />
          <Route path={"/privacy_policy"} exact component={termosCondicoes} />
          <Route path={"/contact"} exact component={Contact} />*/}

          {/*<Route path={"/mapa_pistas"} exact component={MapaPistas} />
          <Route path={"/livecam"} exact component={LiveCam} />
          <Route path={"/accesses"} exact component={Accesses} />*/}

          <Route path={"/project"} render={(props) => <AboutCustom {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={AboutCustom}*/ exact={true} />

          <Route path={"/pag/:pag_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />

          <Route path={"/article/:article_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
          <Route path={"/press/:press_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
          <Route path={"/gallery/:gallery_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />
          {/*<Route path={"/partner/:partner_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} exact={true} />*/}
          <Route path={"/store/product/:product_id"} component={Store} exact={true} />


          {/*<Route path={"/desk"} component={ProdByCategoryDesk} exact={true} />*/}

          {/*<Route path={"/desk/cart"} component={CartDesk} exact={true} />
          <Route path={"/desk/service/:product_id"} component={ProdByIdDesk} exact={true} />*/}

          {/*<Route path={"/store/forfaits"} component={Forfaits} exact={true} />
          <Route path={"/store/equipments"} component={Equipamentos} exact={true} />*/}

          {/*
          <Route path={"/store/vouchers"} component={Vouchers} exact={true} />
          */}
          <Route path={"/store/packs"} component={Packs} exact={true} />
          <Route path={"/store/activities"} component={Atividades} exact={true} />
          {/*<Route path={"/store/aulas"} component={Aula_Store} exact={true} />*/}


          {/*<Route path={"/reservation/service/:id"} component={Service} exact={true} />
          <Route path={"/reservation/service"} component={Reservas} exact={true} />*/}

          {/*<Route path={"/store/:category"} component={ProdByCategory} exact={true} />
          <Route path={"/store"} component={GenericStore} exact={true} />*/}

          {/*<Route path={"/reservation/entrance"} component={Entrance} exact={true} />*/}

          {/*<Route path={"/reservation/cart"} component={GoldenRock_Cart} exact={true} />*/}

          <Route path={"/store/cart"} component={Cart} exact={true} />
          <Route path={"/store/payment/notification/status/:key/:state"} component={PaymentNotificationPage} exact={true} />
          <Route path={"/app/payment/notification/status/:key/:state"} component={PaymentNotificationPageApp} exact={true} />

          {/*<Route path={"/routes/:routes_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} exact={true} />
          <Route path={"/accommodation/:accommodation_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} exact={true} />
          <Route path={"/restaurant/:restaurant_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} exact={true} />
          <Route path={"/events/:event_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} exact={true} />
          <Route path={"/animation/:animation_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} exact={true} />*/}

          {/*<Route path={"/client/perfil"} component={PerfilClient} exact={true} />
          <Route path={"/client/order"} component={OrdersClient} exact={true} />
          <Route path={"/client/historic"} component={HistoricClient} exact={true} />

          <Route path={"/regist/client"} component={RegistClient} exact={true} />
          <Route path={"/regist/client/recovery/:hash"} component={RecoveryClient} exact={true} />*/}

          <Route path={"/regist/farmer"} render={(props) => <RegistFarmer {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={RegistFarmer}*/ exact={true} />
          <Route path={"/regist/farmer/recovery/:hash"} render={(props) => <RecoveryFarmer {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={RecoveryFarmer}*/ exact={true} />
          <Route path={"/study/:study_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />

          <Route path={"/preview/:preview_id"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />

          {/*   <Route exact path={Hosts.WEB_SITE_URI + "contacts"} component={Contact} /> */}

          {/*  <Route path={Hosts.WEB_SITE_URI + "terms_conditions"} exact component={termosCondicoes} />
          <Route path={Hosts.WEB_SITE_URI + "privacy_policy"} exact component={politicaPrivacidade} /> */}
          <Route path={"/:slug"} render={(props) => <Content {...props} dados_config={dados_config.current} dados_navbar={navbar.current} />} /*component={Content}*/ exact={true} />

          <Redirect to="/" />


        </Switch >
      </>

    </>


}

export default App;

